import React from 'react';

const vehicleIcons = ['mot', 'sed', 'suv', 'pic', 'van'];
function vehicleIcon(order) {
    return vehicleIcons[order.vehicleType - 1];
}

export function VehicleIcon({ order }) {
    return (
        <div className="float-right">
            <img className="vehicle-icon" src={`./${vehicleIcon(order)}.svg`} />
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/components/sidebarOrders/order/VehicleIcon.js